import React from "react";
import { useNavigate } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";

function NotFound(){
  const navigate = useNavigate();

  return (
    <div className="notfound-wrapper">
      <div className="notfound-container">
        <FaExclamationTriangle className="notfound-icon" />
        <h1>Oops... Página No Encontrada</h1>
        <p>La sesión ha expirado o la página que buscas no existe.</p>
        <button className="notfound-button" onClick={() => navigate("/")}>
          Volver al Inicio
        </button>
      </div>
    </div>
  );
};

export  {NotFound};
